// @ts-ignore
const BASE_DOMAIN = import.meta.env.VITE_API_BASE_DOMAIN;

if (!BASE_DOMAIN) {
  throw new Error('VITE_API_BASE_DOMAIN is not defined');
}

export function buildApiBaseUrl(tenantId: string): string {
  if (!tenantId) throw new Error('tenantId is required');
  return `https://${tenantId}.api.${BASE_DOMAIN}/${tenantId}/api`;
}
